import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Plus } from "lucide-react";

import { RecentThreads } from "@/components/workroom/RecentThreads";
import { Spinner } from "@/components/ui/Spinner";
import { useThreads } from "@/hooks/useThreads";

export const Route = createFileRoute("/_authenticated/chat-history")({
  component: ChatHistoryRoute,
});

function ChatHistoryRoute() {
  const { threads, isLoading, createThread, deleteThread } = useThreads();
  const navigate = useNavigate();

  if (isLoading) return <Spinner />;

  const handleNewChat = () => {
    createThread({ title: "New Chat" })
      .then((threadId) => {
        void navigate({ to: "/chat/$threadId", params: { threadId: threadId as string } });
      })
      .catch(() => {});
  };

  return (
    <div className="space-y-6 p-6 lg:p-8">
      <div className="flex items-center justify-between">
        <h1 className="font-heading text-4xl font-bold text-black dark:text-white">Chat History</h1>
        <button
          onClick={handleNewChat}
          className="flex items-center gap-2 rounded-xl bg-brand-coral px-4 py-2 text-sm font-bold text-white transition hover:bg-brand-coral/90"
        >
          <Plus className="h-4 w-4" />
          New Chat
        </button>
      </div>

      <RecentThreads
        threads={(threads ?? []) as Array<{ _id: string; title: string; lastMessageAt: number; metadata?: { templateName?: string } }>}
        onDelete={({ threadId }) => void deleteThread({ threadId: threadId as any })}
      />
    </div>
  );
}
